import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FavoriteMenu } from '../models/favoriteMenu.model';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  endpoint = `${environment.apiFramework}`;
  private applicationFavorite = new BehaviorSubject<any>(undefined);
  private applicationTitle = new BehaviorSubject<any>(undefined);
  private menuLogo = new Subject<any>();
  showSearchMenu: any = true;
  isExistModule: number;
  constructor(private http: HttpClient) {}

  setShowSearchMenu() {
    this.showSearchMenu = !this.showSearchMenu;
  }

  getShowSearchMenu() {
    return this.showSearchMenu;
  }

  setFavoriteApplication(moduleFavorite: any): void {
    this.applicationFavorite.next(moduleFavorite);
  }

  getFavoriteApplication(): Observable<any> {
    return this.applicationFavorite.asObservable();
  }

  getMenuFavorite(): Observable<FavoriteMenu[]> {
    return this.http.get<any>(`${this.endpoint}/Applications/GetAllFavoritesForUser`);
  }

  addFavorite(module: any): Observable<void> {
    return this.http.get<void>(`${this.endpoint}/Applications/UpdateFavoriteForUser/${module.id}`);
  }

  setApplicationTitle(title: string): void {
    localStorage.setItem('titleApplication', title);
    this.applicationTitle.next(title);
  }

  getApplicationTitle(): Observable<string> {
    return this.applicationTitle.asObservable();
  }

  setStatusLogo(status: boolean): void {
    this.menuLogo.next(status);
  }

  getStatusLogo(): Observable<any> {
    return this.menuLogo.asObservable();
  }
}
